import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import SegmentMessage from "../../components/forms/messages/SegmentMessage.jsx";
import LoginForm from "../../components/sentry/LoginForm.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import { doMarketplaceLogin } from "../../state/reducers/authentication/authenticationActions.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

import { ROUTES } from "../../constants/routing.js";

class LoginMarketplace extends PureComponent {
  static propTypes = {
    doMarketplaceLogin: PropTypes.func.isRequired,
    resetErrors: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const { provider, token, section, action } = props.match.params;

    this.state = {
      provider,
      token
    };
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    const { provider } = this.state;
    const { token } = this.state;
    this.props.resetErrors();
    this.props.doMarketplaceLogin(
      values.username,
      values.password,
      provider,
      token
    );
  };

  // -- RENDER -- //

  renderMessage = copyKey => {
    const { copy } = this.props;

    return (
      <SegmentMessage
        title={copy(`${copyKey}.title`)}
        message={copy(`${copyKey}.message`)}
        className="sentry-form-message"
        info={true}
      />
    );
  };

  doManageCookies = () => {
    console.log("COOKIES!!!");
    Cookiebot.renew();
    console.log("COOKIES DONE!!!");
  };

  render() {
    const { provider } = this.state;
    const { token } = this.state;
    const { copy } = this.props;

    var title = copy("sentry.login_marketplace.title");
    var title = title.replace(/\*marketplaceProvider/g, provider.toUpperCase());

    var description = copy("sentry.login_marketplace.description");
    description = description.replace(
      /\*marketplaceProvider/g,
      provider.toUpperCase()
    );

    var newURL = "".concat(
      ROUTES.MARKETPLACE_REGISTER,
      "/",
      provider.toLowerCase(),
      "/",
      token
    );

    const copyKey = "sentry.login";

    return (
      <div className="sentry-form">
        <Header as="h3" inverted textAlign="center">
          {copy(`${copyKey}.title`)}
        </Header>

        <div>
          <div class="ui small icon info message segment-message clear-both">
            <i aria-hidden="true" class="cloud icon"></i>
            <div class="content">
              <div class="header">{title}</div>
              <p>{description}</p>
            </div>
          </div>
        </div>

        <ErrorBoundary>
          <LoginForm onSubmit={this.onSubmit} />
          <footer>
            <LinkWithReset to={newURL}>
              {copy(`${copyKey}.marketplace_sign_up_cta`)}
            </LinkWithReset>
          </footer>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  doMarketplaceLogin: (username, password, provider, token) =>
    dispatch(doMarketplaceLogin(username, password, provider, token)),
  resetErrors: () => dispatch(resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginMarketplace);
